import ApiBase, { baseUrl } from '.';

export default class MediaApi extends ApiBase {
  constructor(token) {
    super(`${baseUrl}/api/services/app/Role`, token);
  }

  getRoles() {
    return this.authHttp.get(`${this.baseUrl}/GetRoles`);
  }
}
